import {autoPhotoLabels} from '../../data/constants/Contrats/contratRattacher';
import {IValues} from '../../data/types/interface/Contrats/contratRattacher';

export const addPhotosToFormData = (values: IValues, formData: FormData) => {
  autoPhotoLabels.forEach(a => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const value = (values as {[key: string]: any})[a.name][0];
    if (value) {
      formData.append(a.name, value);
    }
  });

  return new Promise<void>(resolve => resolve());
};
